/**
 * The one guard every bare-letter shortcut in this app needs: **is the player writing?**
 *
 * The action box has no modifier and no focus discipline around it — it is a plain text
 * input sitting at the foot of the story screen — so an unguarded `w` eats the first letter
 * of *"walk north"* and an unguarded `1` eats the first character of *"1 token for the
 * water"*. Every `keydown` handler on `document` has to ask this before it does anything.
 *
 * It is checked against the **event target** rather than against a global "a field has
 * focus" flag, because the target is the only thing that is also true of a
 * `contenteditable`, and because a handler that consults `document.activeElement` is
 * answering a question about the page rather than about the keystroke it was handed.
 *
 * Two callers today: `WorldPanel`'s `w` and `Choices`' `1`–`6`. It lives here rather than
 * beside either of them because the next shortcut (`TODO.md` §8.4's sheet) will want it too
 * and copying it is how the two copies drift.
 */
export function isTyping(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  if (target.isContentEditable) return true;
  return ['INPUT', 'TEXTAREA', 'SELECT'].includes(target.tagName);
}
